import {
    createAction,
    createSlice
} from '@reduxjs/toolkit';
import { APIConnectionRecord, CoreMsgTypes } from '@tassat/fred-definitions';

export interface APIConnectionState {
    [key: string]: APIConnectionRecord;
}

const initialState: APIConnectionState = {};

const initialLoadAction = createAction<{ apiconnections: {
    [apiConnectionId: string]: APIConnectionRecord;
}; }>('InitialLoad');
const setApiConnectionsAction = createAction<APIConnectionRecord[]>('SET_API_CONNECTIONS');
const apiConnectionRecordAction = createAction<APIConnectionRecord>(CoreMsgTypes.APIConnectionRecord);

const apiConnectionSlice = createSlice({
    name: 'apiConnections',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(initialLoadAction, (_state, action) => action.payload.apiconnections)
            .addCase(setApiConnectionsAction, (state, action) => {
                const mappedApiConnections = {};
                action.payload.forEach((apiConnection) => {
                    mappedApiConnections[apiConnection.APIConnectionId] = {
                        ...apiConnection,
                        apiconnectionusers: {}
                    };
                });

                return {
                    ...state,
                    ...mappedApiConnections
                };
            })
            .addCase(apiConnectionRecordAction, (state, action) => {
                state[action.payload.APIConnectionId] = action.payload;
            })
            .addDefaultCase((state) => state);
    }
});

export default apiConnectionSlice.reducer;